import { useLocation } from "@tanstack/react-router"
import { useEffect, useState } from "react";

export function PreviewFiles(){
    const [imagePath, setImagePath] = useState<string | null>(null);
    const {search} = useLocation();

    useEffect(()=>{
   if(search.imagePath){
    setImagePath(decodeURIComponent(search.imagePath))
   }
    },[search])

    return <div className="fixed top-0 left-0 right-0 bottom-0 z-50 bg-black bg-opacity-50 overflow-y-auto">
    <img src={imagePath} alt={imagePath} width={"100%"} height={"100%"}/>
    </div>
}